// import logger from 'redux-logger';
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from '@redux-saga/core';
import { applyMiddleware, createStore, Middleware } from 'redux';

import rootReducer from './root-reducer';

export const sagaMiddleware = createSagaMiddleware();

// Add middlewares here
const middlewares = [sagaMiddleware] as Middleware[];

// logger must go last
if (process.env.REACT_APP_ENABLE_LOG === 'true') {
  // middlewares.push(logger);
}

// use configureStore instead of createStore for redux devtools browser ext logging
export const store = (process.env.REACT_APP_ENABLE_LOG === 'true') ? configureStore({
  reducer: rootReducer,
  middleware: middlewares
}) :
  createStore(
    rootReducer,
    applyMiddleware(...middlewares)
  );

/*
    Must be initialized after axios config file, since sagas depend on it.
    axios config file depends on store, so this creates a circular dependency.
    Initialized in index.tsx after configuration files are initialized
*/
// sagaMiddleware.run(rootSaga);

export default store;
